<div class="header" *puSpinner="isLoading">
  <h4 class="header-text">
    {{ 'supportForm.title.' + (category || 'finance') | translateIn }}
  </h4>

  <button
    class="close"
    type="button"
    puButton
    size="m"
    uiType="quaternary"
    [onlyIcon]="true"
    (click)="close()">
    <pu-icon iconName="close" size="16" />
  </button>
</div>

<form [formGroup]="form" class="body" (ngSubmit)="submit()">
  <div class="message">
    <img class="image" [src]="assetsUrl + '/assets/images/support-message.png'" alt="message.png" />

    <p class="text">
      {{ 'supportForm.' + (category === 'finance' ? 'financial' : 'text') | translateIn }}
    </p>
  </div>

  @switch (category) {
    @case (categoriesEnum.education) {
      <pu-select
        class="courses"
        formControlName="course"
        valueField="lmsCourseId"
        [label]="'supportForm.course.label' | translateIn"
        [items]="(courses | async)?.courses || [] | withNotRelatedOption"
      />

      <pu-simple-input
        class="subject"
        formControlName="subject"
        [label]="'supportForm.subject.label' | translateIn"
      />
    }
    @case (categoriesEnum.office) {
      <ng-container formGroupName="extraInformation">
        <pu-select
          class="location"
          formControlName="location_id"
          [label]="'supportForm.location.label' | translateIn"
          [items]="(locations | async)?.locations || []"
          required
        />

        <pu-simple-input
          class="space"
          formControlName="office_space"
          [label]="'supportForm.space.label' | translateIn"
        />

        <pu-simple-input
          class="floor"
          formControlName="office_floor"
          [label]="'supportForm.floor.label' | translateIn"
        />
      </ng-container>
    }
    @case (categoriesEnum.finance) {
      <pu-select
        class="courses"
        formControlName="financialCategory"
        [label]="'supportForm.categories.label' | translateIn"
        [placeholder]="'supportForm.categories.placeholder' | translateIn"
        [items]="(financialCategories | async)?.categories || []"
        (puControlValueChanges)="changeFinancialCategoryId($event)"
      >
        <ng-template
          #itemTpl
          let-item
        >
          <div class="pu-select-list-financial-category-item">
            <span class="pu-select__item-name">
              {{ item.name }}
            </span>
            <span class="pu-select__item-description">
              {{ item.description }}
            </span>
          </div>
        </ng-template>
      </pu-select>
      @if (selectedFinancialCategoryId()) {
        <p class="financial-category-description">
          {{ '• ' + getDescription((financialCategories | async)?.categories || []) }}
        </p>
      }
    }
  }

  <pu-text-area
    class="question"
    formControlName="text"
    [rows]="4"
    [label]="'supportForm.question.label' | translateIn"
    [placeholder]="'supportForm.question.placeholder' | translateIn"
  />

  <div class="images">
    <pu-uploader
      #uploader
      class="images-uploader"
      formControlName="images"
      [apiS3]="apiS3Url() ?? 'upload/image/'"
      [apiHost]="apiHost"
      accept=".pdf,.xlsx,.xls,.docx,.doc,.jpg,.jpeg,.png"
      [acceptLabelKey]="acceptLabelKey"
      placeholderKey="supportForm.images.placeholder"
      subPlaceholderKey="supportForm.images.subPlaceholder"
      multiple
      [maxFileSize]="maxFileSize"
      [maxFileSizeLabelKey]="maxFileSizeLabelKey"
    >
      <ng-template #filesTpl>
        @if (uploader.files.length) {
          @for(file of uploader.files; track $index) {
            @if (isNotImage(file.name)) {
              <div class="pu-uploader-file" (click)="uploader.removeFile($event, 0)">
                <pu-icon iconName="info" size="20" />

                <span class="pu-uploader-file__name">
                  {{ file.name }}
                </span>

                <div class="pu-uploader-file__remove">
                  <pu-icon iconName="close" size="16" />
                </div>
              </div>
            } @else {
              <div class="pu-uploader-image" (click)="uploader.removeFile($event, 0)">

                <img class="pu-uploader-image__img" ptImageLoader [src]="file.url" [alt]="file.name" />

                <div class="pu-uploader-image__remove">
                  <pu-icon iconName="pu-close" size="16" />
                </div>
              </div>
            }
          }
        }
      </ng-template>
    </pu-uploader>
  </div>

  <div class="actions">
    <button
      type="submit"
      puButton
      size="l"
      uiType="primary"
      [disabled]="form.invalid"
    >{{ 'supportForm.buttons.send' | translateIn }}</button>

    <button
      type="button"
      puButton
      size="l"
      uiType="secondary"
      (click)="close()"
    >{{ 'supportForm.buttons.close' | translateIn }}</button>
  </div>
</form>
